var render, staticRenderFns
import script from "./RatingList.vue?vue&type=script&lang=js"
export * from "./RatingList.vue?vue&type=script&lang=js"
import style0 from "./RatingList.vue?vue&type=style&index=0&id=017e0706&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017e0706",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/myc-feat.learningsystem.de/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017e0706')) {
      api.createRecord('017e0706', component.options)
    } else {
      api.reload('017e0706', component.options)
    }
    
  }
}
component.options.__file = "resources/js/components/RatingList.vue"
export default component.exports